import { useEffect, useState } from 'react';

import PubSub from 'common/utils/PubSub';

import { DrawerIdEnum } from 'features/org-root/enums/drawer-id.enum';

const drawerPubSub = new PubSub();
const openDrawers = new Set<DrawerIdEnum>();

const openDrawer = (drawerId: DrawerIdEnum, drawerProps: any) => {
  openDrawers.add(drawerId);
  if (!drawerProps.toggleDrawer) {
    drawerProps.toggleDrawer = () => closeDrawer(drawerId);
  }
  drawerPubSub.publish({
    open: true,
    drawerId,
    drawerProps,
  });
};

const closeDrawer = (drawerId: DrawerIdEnum) => {
  openDrawers.delete(drawerId);
  drawerPubSub.publish({
    drawerId,
    open: false,
  });
};

export const useDrawerOpen = (drawerId: DrawerIdEnum) => {
  const [open, setOpen] = useState(() => openDrawers.has(drawerId));
  useEffect(() => {
    const subscriber = (state: { drawerId: DrawerIdEnum; open: boolean }) => {
      if (state.drawerId === drawerId) setOpen(state.open);
    };
    drawerPubSub.subscribe(subscriber);
    setOpen(openDrawers.has(drawerId));
    return () => drawerPubSub.unsubscribe(subscriber);
  }, [drawerId]);
  return open;
};

const useDrawer = (subscriber?: Function) => {
  useEffect(() => {
    if (subscriber) {
      drawerPubSub.subscribe(subscriber);
      return () => {
        drawerPubSub.unsubscribe(subscriber);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    openDrawer,
    closeDrawer,
  };
};

export default useDrawer;
